import { format, addDays } from 'date-fns';

const monthsAbbr = ['Jan.', 'Fev.', 'Mar.', 'Abr.', 'Mai.', 'Jun.', 'Jul.', 'Ago.', 'Set.', 'Out.', 'Nov.', 'Dez.'];
const weekDaysAbbr = ['DOM.', 'SEG.', 'TER.', 'QUA.', 'QUI.', 'SEX.', 'SÁB.'];

/**
 * Formats a date to a custom format: "DOM. 01 Jan."
 */
export const formatCustomDate = (date: Date): string => {
  const weekDayIndex = date.getDay();
  const day = format(date, 'dd');
  const monthIndex = parseInt(format(date, 'MM')) - 1;

  return `${weekDaysAbbr[weekDayIndex]} ${day} ${monthsAbbr[monthIndex]}`;
};

/**
 * Formats a week range: "Jan. 2024" or "Jan. – Fev. 2024"
 */
export const formatWeekRange = (startDate: Date): string => {
  const endDate = addDays(startDate, 6);
  const startMonth = monthsAbbr[startDate.getMonth()];
  const endMonth = monthsAbbr[endDate.getMonth()];
  const year = startDate.getFullYear();

  return startMonth === endMonth ? `${startMonth} ${year}` : `${startMonth} – ${endMonth} ${year}`;
};

export { monthsAbbr, weekDaysAbbr };
